import { LeadConcurrence } from './leadConcurrence';

export class LeadsConcurrencesResponse {
    leads: LeadConcurrence[];
}
